import { render, staticRenderFns } from "./AlarmQueuePriorityColors.vue?vue&type=template&id=5b588326&scoped=true"
import script from "./AlarmQueuePriorityColors.vue?vue&type=script&lang=ts"
export * from "./AlarmQueuePriorityColors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b588326",
  null
  
)

export default component.exports